export default [
  {
    id: '8bf2d32a-c691-4df0-a570-8ece72595f5e', // id 全局唯一，终身制
    name: 'portal',
    path: '/',
    meta: {
      title: '门户首页',
    },
    layout: 'fullscreen',
    children: [
      {
        id: 'a720a5aa-bf99-4328-8f92-ee9cfb06478a',
        path: 'portal',
        name: 'portalIndex',
        meta: {
          title: '门户首页',
          tabnab: false,
          hidden: true,
        },
        component: () => {
          return import('./views/index')
        },
        children: [
          {
            id: 'e6c44b0a-077e-4101-9c5f-ec40af7a4fea',
            path: 'homepage',
            name: 'homepage',
            meta: {
              title: '首页',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/Homepage')
            },
          },
          {
            id: 'fadfc74b-06d7-4566-aff2-8d74ca25b7c9',
            path: 'appCenter',
            name: 'appCenter',
            meta: {
              title: '应用中心',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/AppCenter')
            },
          },
          {
            id: '1b377940-fcca-4a09-967b-d20449bd8914',
            path: 'search',
            name: 'search',
            meta: {
              title: '搜索',
              tabnab: false,
            },
            component: () => {
              return import('./views/SearchPage')
            },
          },
          {
            id: '43ee00ff-e3ed-476b-980f-328046e89be5',
            path: 'workbench',
            name: 'workbench',
            meta: {
              title: '工作台',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/Workbench')
            },
          },
          {
            id: 'bbeb2bfb-3897-47b9-a019-b3f1e6e9a9aa',
            path: 'workflows',
            name: 'workflows',
            meta: {
              title: '工作流详情',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/Workflows')
            },
          },
          {
            id: 'a0b8bcb9-9b54-4d01-b8bc-2a8f33abcbba',
            path: 'addressBook',
            name: 'addressBook',
            meta: {
              title: '通讯录',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/AddressBook')
            },
          },
          {
            id: '8649faf3-4637-466d-9430-90d31bc7076c',
            path: 'message',
            name: 'message',
            meta: {
              title: '消息',
              tabnab: false,
              hidden: true,
            },
            component: () => {
              return import('./views/Message')
            },
          },
          {
            id: '65945b13-6737-4117-a1e1-7ebe9f86830b',
            path: 'ColumnDetail',
            name: 'ColumnDetail',
            meta: {
              title: '栏目详情',
              tabnab: false,
            },
            component: () => {
              return import('./views/ColumnDetail')
            },
          },
        ],
      },
      {
        id: '05a778da-50e6-40f8-86b8-21a39eb9ea47',
        path: 'workplace-safety',
        name: 'workplaceSafety',
        meta: {
          title: '安全生产',
          tabnab: false,
          hidden: true,
        },
        component: () => {
          return import('./views/WorkplaceSafety')
        },
        children: [],
      },
      {
        id: 'ca5c20fe-5f90-4b1e-b009-21e5b9b68d35',
        path: 'attachments-view',
        name: 'AttachmentsView',
        component: () => {
          return import('./views/AttachmentsView')
        },
        meta: {
          title: '查看附件',
          hidden: true,
          tabnab: false,
        },
        children: [],
      },
    ],
  },
]
